// extracted by mini-css-extract-plugin
module.exports = {"editorArea":"editorArea___GPASl","editorWrap":"editorWrap___3b5J1","editor":"editor___3uCA-"};